/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Terms_Privacy_RequiredInputs */

const en_validation_terms_privacy_required = /** @type {(inputs: Validation_Terms_Privacy_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please accept the privacy policy.`)
};

const de_validation_terms_privacy_required = /** @type {(inputs: Validation_Terms_Privacy_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte stimmen Sie der Datenschutzerklärung zu.`)
};

/**
* | output |
* | --- |
* | "Please accept the privacy policy." |
*
* @param {Validation_Terms_Privacy_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const validation_terms_privacy_required = /** @type {((inputs?: Validation_Terms_Privacy_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Terms_Privacy_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_validation_terms_privacy_required(inputs)
	return en_validation_terms_privacy_required(inputs)
});